var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user_role != 'manager' && _vm.user_role != 'moderator' && _vm.add_monitor_btn == true)?_c('button',{staticClass:"btn custom-font-24",class:_vm.btn_class,on:{"click":_vm.AddMonitor}},[_vm._v("+ Add New Monitor")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }